.windowContainer {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background: rgba(17, 24, 39, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.6), 0 2px 8px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  user-select: none;
  transition: box-shadow 0.2s ease;
}

.windowContainer:focus-within {
  border-color: var(--color-primary, #3b82f6);
  box-shadow: 0 16px 44px rgba(0, 0, 0, 0.7), 0 0 0 1px var(--color-primary, #3b82f6);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: rgba(31, 41, 55, 0.85);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: grab;
}

.header:active {
  cursor: grabbing;
}

.headerLeft {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title {
  font-size: 13px;
  font-weight: 600;
  color: #f3f4f6;
  letter-spacing: 0.3px;
}

.liveBadge {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.liveBadgeRunning {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.4);
}

.liveBadgeStopped {
  background: rgba(156, 163, 175, 0.15);
  color: #9ca3af;
  border: 1px solid rgba(156, 163, 175, 0.3);
}

.liveDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: currentColor;
}

.headerRight {
  display: flex;
  align-items: center;
  gap: 4px;
}

.screenSelect {
  background: rgba(17, 24, 39, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #e5e7eb;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 4px;
}

.headerBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #9ca3af;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  transition: all 0.15s ease;
}

.headerBtn:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.headerBtnClose:hover {
  background: #ef4444;
  color: #ffffff;
}

.bezel {
  padding: 10px;
  background: #0f172a;
  display: flex;
  justify-content: center;
  align-items: center;
}

.viewportContainer {
  position: relative;
  overflow: hidden;
  border: 2px solid #334155;
  border-radius: 6px;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.6);
}

.canvasInner {
  position: relative;
  transform-origin: top left;
}

.minimizedPill {
  position: absolute;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: rgba(17, 24, 39, 0.92);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(16, 185, 129, 0.4);
  border-radius: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  color: #f3f4f6;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.minimizedPill:hover {
  background: rgba(31, 41, 55, 0.95);
  border-color: #10b981;
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.6);
}

.emptyState {
  padding: 24px 16px;
  text-align: center;
  color: #9ca3af;
  font-size: 12px;
  line-height: 1.5;
}
